
export const updateLinks = () => {
  const list = [...document.querySelectorAll('.body a[href*="#"], .info-attr a[href*="#"], .content-attr a[href*="#"], .body a[href*="mailto:"], .info-attr a[href*="mailto:"], .content-attr a[href*="mailto:"]')]
  list.forEach((el, index) => {
    el.classList.add("no-as")
  })
  
}

